import CryptoJS from 'crypto-js';

const keyStr: string = 'paretoolipo666';
const ivStr: string = 'ipo888';

const key: CryptoJS.lib.WordArray = CryptoJS.enc.Utf8.parse(keyStr);
const iv: CryptoJS.lib.WordArray = CryptoJS.enc.Utf8.parse(ivStr);

// 加密
export const encrypted: (str: string) => string = str => {
	const en: CryptoJS.lib.CipherParams = CryptoJS.RC4.encrypt(str, key, { iv });
	// 转换为字符串
	const encrypt = en.toString();
	return encrypt;
};

// 解密
export const decrypted: (str: string) => string = str => {
	const de = CryptoJS.RC4.decrypt(str, key, { iv });
	// 转换为 utf8 字符串
	const decrypt = CryptoJS.enc.Utf8.stringify(de);
	return decrypt;
};

// 加密
export const encryptedAes: (str: string, keyStr?: string) => string = (
	str,
	keyStr = 'paretoolP@ssw-rd',
) => {
	let key: CryptoJS.lib.WordArray = CryptoJS.enc.Utf8.parse(keyStr);
	let iv: CryptoJS.lib.WordArray = CryptoJS.enc.Utf8.parse('');
	let en: CryptoJS.lib.CipherParams = CryptoJS.AES.encrypt(str, key, {
		iv: iv,
		mode: CryptoJS.mode.ECB,
		padding: CryptoJS.pad.Pkcs7,
	});
	let encryptedStr = en.ciphertext.toString();
	let encryptedHexStr = CryptoJS.enc.Hex.parse(encryptedStr);
	let encrypt = CryptoJS.enc.Base64.stringify(encryptedHexStr);
	return encrypt;
};
export const decryptedAes: (str: string) => string = (str, keyStr = 'paretoolP@ssw-rd') => {
	let key: CryptoJS.lib.WordArray = CryptoJS.enc.Utf8.parse(keyStr);
	let iv: CryptoJS.lib.WordArray = CryptoJS.enc.Utf8.parse('');
	let decryptedData = CryptoJS.AES.decrypt(str, key, {
		iv: iv,
		mode: CryptoJS.mode.ECB,
		padding: CryptoJS.pad.Pkcs7,
	});
	let decryptedStr = CryptoJS.enc.Utf8.stringify(decryptedData);
	return decryptedStr;
};
